/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelRecordDataFile', 'model/ForecastModelRecordDataFileReport', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForecastModelRecordDataFile'), require('../model/ForecastModelRecordDataFileReport'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelRecordDataFileApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelRecordDataFile, root.ForStractionServiceApi.ForecastModelRecordDataFileReport, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, ForecastModelRecordDataFile, ForecastModelRecordDataFileReport, FileTransferHelperEntity) {
  'use strict';

  /**
   * ForecastModelRecordDataFile service.
   * @module api/ForecastModelRecordDataFileApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForecastModelRecordDataFileApi. 
   * @alias module:api/ForecastModelRecordDataFileApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the forecastModelRecordDataFileAddPut operation.
     * @callback module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelRecordDataFile} body 
     * @param {module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.forecastModelRecordDataFileAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataFileAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelRecordDataFileAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForecastModelRecordDataFile/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataFileDeleteGet operation.
     * @callback module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelRecordDataFileDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataFileDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling forecastModelRecordDataFileDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelRecordDataFile/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataFileEditPut operation.
     * @callback module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelRecordDataFile} body 
     * @param {module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelRecordDataFileEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataFileEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelRecordDataFileEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelRecordDataFile/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataFileLoadGet operation.
     * @callback module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelRecordDataFileReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelRecordDataFileReport}
     */
    this.forecastModelRecordDataFileLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataFileLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling forecastModelRecordDataFileLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelRecordDataFileReport;

      return this.apiClient.callApi(
        '/ForecastModelRecordDataFile/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataFileUploadFilePut operation.
     * @callback module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileUploadFilePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelRecordDataFileReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * uploadFile
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.recordID 
     * @param {Integer} opts.fileID 
     * @param {module:api/ForecastModelRecordDataFileApi~forecastModelRecordDataFileUploadFilePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelRecordDataFileReport}
     */
    this.forecastModelRecordDataFileUploadFilePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataFileUploadFilePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelRecordDataFileUploadFilePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'recordID': opts['recordID'],
        'fileID': opts['fileID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelRecordDataFileReport;

      return this.apiClient.callApi(
        '/ForecastModelRecordDataFile/uploadFile', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
